// extracted by mini-css-extract-plugin
module.exports = {"headerButton":"clinical-portal-3__HeaderBackButton__headerButton"};